"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AllPassMessage = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var AllPassMessage = function AllPassMessage() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-5 text-center text-xs"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "rounded-full bg-gray-divider inline-block mx-auto p-2 mb-1"
  }, /*#__PURE__*/_react["default"].createElement(_Check["default"], {
    className: "text-gray-light !text-4xl"
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "my-3"
  }, t('message.readReceiptBlocking.pass')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "my-3"
  }, t('message.suspiciousDetecting.pass')));
};

exports.AllPassMessage = AllPassMessage;
//# sourceMappingURL=index.js.map